import { connect } from "react-redux";
import React from 'react';

import { hideLoginModal } from "../../store/actions";

import Email from "./Email";
import Modal from "../Shared/Modal";

const Login = (props) => {

  return (
    <Modal onClose={props.hideLoginModal} labelledBy="login-title" width={440}>
      <Email/>
    </Modal>
  );
};

const mapDipatchToProps = (dispatch) => ({
    hideLoginModal: () => dispatch(hideLoginModal())
});

export default connect(null, mapDipatchToProps)(Login);
